import { render, staticRenderFns } from "./BudgetForms.vue?vue&type=template&id=5504841b&scoped=true&"
import script from "./BudgetForms.vue?vue&type=script&lang=js&"
export * from "./BudgetForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504841b",
  null
  
)

export default component.exports